import React, { useEffect } from "react";

export const useOnStopScroll = (
  scrollRef,
  handler,
  time,
) => {
  useEffect(() => {
    const listener = (element) => {
      const timeout = time;
      let removed = false;
      let handle = null;
      const onScroll = () => {
        if (handle) {
          clearTimeout(handle);
        }
        handle = window.setTimeout(handler, timeout);
      };
      element?.addEventListener("scroll", onScroll);
      return () => {
        if (removed) {
          return;
        }
        removed = true;
        if (handle) {
          clearTimeout(handle);
        }
        element?.removeEventListener("scroll", onScroll);
      };
    };

    listener(scrollRef.current);
  });
};